import React, { Component } from 'react';

class PageNotFound extends Component {
  render(){  
    return <div>Erreur 404</div>;
  } 
}

export default PageNotFound;
